import React from "react"
import { useIntl } from "react-intl"
// Material Ui
import Button from "@material-ui/core/Button"
import { propTypes, containedSecondary } from "./ButtonPropTypes"
import { words } from "../../i18n/lstrings"

const ButtonDelete = (props) => {
  const { formatMessage: format } = useIntl()
  return (
    <Button {...props}>
      <i aria-hidden="true" className="far fa-trash-alt" />
      {format(words.delete)}
    </Button>
  )
}

ButtonDelete.propTypes = propTypes
ButtonDelete.defaultProps = containedSecondary

export default ButtonDelete
